import script from "./login-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./login-panel.vue?vue&type=script&setup=true&lang=ts"

import "./login-panel.vue?vue&type=style&index=0&id=2413076e&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2413076e"]])

export default __exports__